export function convertToCSV(data, options = {}) {
  const { columns, delimiter = ',' } = options;

  // Accept either an object-of-objects ({id: {...}, id2: {...}})
  // or an array of objects ([{...}, {...}])
  const rows = Array.isArray(data) ? data : Object.values(data);

  if (rows.length === 0) return '';

  // Use explicit columns if provided, otherwise infer from the union
  // of all keys across all rows (handles rows with slightly different shapes)
  const headers = columns || Array.from(
    rows.reduce((keys, row) => {
      Object.keys(row).forEach(k => keys.add(k));
      return keys;
    }, new Set())
  );

  const escapeValue = (value) => {
    if (value === null || value === undefined) return '';
    if (value instanceof Date) return value.toISOString();
    if (typeof value === 'object') return JSON.stringify(value); // nested objects/arrays
    return String(value);
  };

  const formatCell = (value) => {
    const str = escapeValue(value);
    // Quote if it contains the delimiter, a quote, or a newline
    if (str.includes(delimiter) || str.includes('"') || str.includes('\n')) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };

  const csvRows = [
    headers.join(delimiter),
    ...rows.map(row => headers.map(h => formatCell(row[h])).join(delimiter))
  ];

  return csvRows.join('\n');
}